var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 19 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.545 0c1.832 0 4.182.956 4.182 3.426 0 1.792-1.195 2.748-2.47 3.186.997 1.434 2.71 3.744 3.466 4.78H5.815L2.71 6.852H2.31v4.54H0V0h3.545zM2.27 4.86h.917c1.155 0 2.031-.439 2.031-1.434 0-.877-.717-1.514-1.753-1.514H2.231V4.86h.04zM15.694 7.09l3.187 4.302h-2.948l-1.753-2.59-1.832 2.59H9.44l3.386-4.342-3.107-4.182h2.988l1.672 2.47 1.713-2.47H19L15.694 7.09z", fill: "#6BC1B6" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/kardia-rx.svg